import { TFunction } from 'i18next';

export const options = (t: TFunction) => [
  {
    label: t('postJobForm.immediateStart.yes'),
    key: true
  },
  {
    label: t('postJobForm.immediateStart.no'),
    key: false
  }
];
